import React, { useState } from "react";
import bg1 from "../assets/bg-image.jpeg";  // Original image
import bg2 from "../assets/bg-image-3.png"; // Background-removed image

export const ImageSlider = () => {
  const [sliderPosition, setSliderPosition] = useState(50);

  const handleSliderChange = (e) => {
    setSliderPosition(e.target.value);
  };

  return (
    <div className="relative w-full max-w-2xl mx-auto h-screen flex items-center justify-center">
      <div className="relative w-[80%] h-[500px]">
        {/* Original Image (background) */}
        <img
          src={bg1}
          alt="Original"
          className="absolute inset-0 w-full h-full object-cover"
        />

        {/* Background Removed Image (on top, clipped dynamically) */}
        <div
          className="absolute inset-0 overflow-hidden"
          style={{ clipPath: `inset(0 ${100 - sliderPosition}% 0 0)` }}
        >
          <img
            src={bg2}
            alt="Background Removed"
            className="w-full h-full object-cover"
          />
        </div>

        {/* Slider */}
        <input
          type="range"
          min="0"
          max="100"
          value={sliderPosition}
          onChange={handleSliderChange}
          className="absolute bottom-4 left-1/2 transform -translate-x-1/2 w-3/4 z-10"
        />
      </div>
    </div>
  );
};

export default ImageSlider;
